// @owners { team: patients }
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { staleTimes } from '~shared/queries/constants';
import { fetchAttestationRequestsByDeliveryId } from '../helpers/fetchAttestationRequestsByDeliveryId';

export const attestationRequestsQueryKeys = createQueryKeys('attestationRequests', {
  fetchByDeliveryId: ({ userID, deliveryID }: { userID: number | null | undefined; deliveryID: number }) => ({
    queryKey: [{ userID, deliveryID }],
    queryFn: () => fetchAttestationRequestsByDeliveryId({ deliveryID }),
  }),
});

export const useQueryAttestationRequests = ({
  userID,
  deliveryID,
}: {
  userID: number | null | undefined;
  deliveryID: number | null | undefined;
}) => {
  const { data, isLoading, isError } = useQuery({
    ...attestationRequestsQueryKeys.fetchByDeliveryId({ userID, deliveryID: deliveryID ?? 0 }),
    staleTime: staleTimes.fiveMinutes,
    enabled: !!userID && !!deliveryID,
  });

  return {
    attestationRequests: data ?? [],
    isLoading,
    isError,
  };
};
